import React from 'react';

const UserMarksHeader = React.memo(({
    onRefresh,
    isLoading = false,
    totalLessons = 0,
    t
}) => {
    return (
        <div className="theme-card summary-card overflow-hidden bg-white p-3 p-md-4 mb-4 shadow-sm anim-fade-up">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
                <div className="d-flex align-items-center mb-2 mb-md-0">
                    <div
                        className="kpi-icon-wrap ml-3 shadow-sm"
                        style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '12px',
                            backgroundColor: '#eef2ff',
                            color: '#4f46e5',
                            fontSize: '1.4rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <i className="fad fa-award"></i>
                    </div>
                    <div>
                        <div className="d-flex align-items-center gap-2">
                            <h4 className="font-weight-bold mb-0 text-dark">
                                {t('Pages.Profile.markList') || 'سِجلّ الدرجات والعلامات'}
                            </h4>
                            <span
                                className="badge badge-primary px-2 py-1 mr-2"
                                style={{
                                    borderRadius: '8px',
                                    fontSize: '0.80rem',
                                    fontWeight: 'bold',
                                    backgroundColor: '#4f46e5'
                                }}
                            >
                                {totalLessons} {t('Pages.Lessons.Lessons') || 'درساً'}
                            </span>
                        </div>
                        <p className="text-muted small mb-0 mt-1">
                            {t('Pages.Lessons.MarksSubtitle') || 'متابعة نتائج الدروس والمحاولات، تشخيص المهارات المحرزة، وقياس مؤشرات الأداء والتطور'}
                        </p>
                    </div>
                </div>

                <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                    <button
                        type="button"
                        onClick={onRefresh}
                        disabled={isLoading}
                        className="btn btn-outline-primary btn-sm d-flex align-items-center px-3 py-2 shadow-sm font-weight-bold"
                        style={{
                            borderRadius: '8px',
                            borderWidth: '1.5px',
                            fontSize: '0.85rem',
                            width: 'auto'
                        }}
                        title={t('Pages.Lessons.refresh') || t('Pages.Missions.refresh') || 'تحديث البيانات'}
                    >
                        <i className={`fas fa-sync-alt ml-1 ${isLoading ? 'fa-spin text-primary' : ''}`}></i>
                        <span>{t('Pages.Lessons.refresh') || t('Pages.Missions.refresh') || 'تحديث'}</span>
                    </button>
                </div>
            </div>
        </div>
    );
});

export default UserMarksHeader;
